<div class="container fw-b d-flex align-items-center justify-content-between flex-wrap" style="margin-top: 27px; gap: 15px;">
  <app-linker-route 
    [headingName]="headingName" 
    [linkerRouteItems]="linkerRouteItems"
    style="margin-top: -11px;">
  </app-linker-route>

  <div class="form-group has-search mb-0">
    <span class="fa fa-search form-control-feedback"></span>
    <input 
      type="text" 
      class="form-control" 
      [(ngModel)]="serviceName" 
      placeholder="Search by booking category"
      (input)="getServiceList(); currentPage = 1" 
    />
  </div>
</div>
<div class="container wrapper-content">
  <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 mt-4">
    <!-- Service Categories List -->
    <ng-container *ngIf="productDetails?.length">
      <div 
        class="col newCardWidth1" 
        *ngFor="let item of productDetails | paginate: {
          itemsPerPage: pageSize,
          currentPage: currentPage,
          totalItems: totalItems
        }; let i = index"
      >
        <div 
          class="innerDiv" 
          (click)="navigateToViewProduct(item?._id, item?.categoryName, item?.description)"
        >
          <category-layout-home 
            [data]="item" 
            [catName]="item?.categoryName">
          </category-layout-home>
        </div>
      </div>
    </ng-container>

    <!-- Skeleton Loaders -->
    <ng-container *ngIf="!productDetails?.length && !isLoading">
      <div 
        class="col newCardWidth1" 
        *ngFor="let item of length(10)"
      >
        <div class="innerDiv">
          <category-layout-home 
            [data]="item" 
            [catName]="item?.categoryName">
          </category-layout-home>
        </div>
      </div>
    </ng-container>

    <!-- No Data State -->
    <div *ngIf="isLoading" class="col-12">
      <div class="no-data">
        <img 
          src="assets/images/notfound.png" 
          alt="No Data Found" 
          class="notfound-img"
        />
        <p>No Data Found</p>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div class="custom-pagination" *ngIf="totalItems > pageSize">
    <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
  </div>
</div>